import { useState } from "react"
import { InventoryServiceProxy } from "../../../data-access/InventoryServiceProxy"

const getWebStock = async (productId, endpointUrl) => {
  let stockClient = new InventoryServiceProxy.Client(endpointUrl)
  return await stockClient.getWebStockGET(productId).then((s) => s)
}

const ProductStockLabel = ({ label, productId, endpointUrl }) => {
  const [state, setState] = useState({
    showWebStock: false,
    webStock: -1,
    fetched: false,
  })

  if (!state.fetched) {
    getWebStock(productId, endpointUrl)
      .then((stock) => {
        setState({
          showWebStock: stock > 0 && stock < 4,
          webStock: stock,
          fetched: true,
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }
  console.log(state.showWebStock)
  return state.showWebStock ? label?.replace("{{Stock}}", state.webStock) || state.webStock : ""
}

export default ProductStockLabel
